import axios from 'axios';

export async function getImagesByQuery(query, page) {
    const BASE_URL = 'https://pixabay.com/api/';
    const API_KEY = '54246352-35184811c7b33f51a38e3c8ed';       // Kлюч API

                                                                // Створюю обєкт з налаштуваннями запиту
    const searchParams = {
        params: {
            key: API_KEY,
            q: query,                                           // Пошуковий запит
            image_type: 'photo',
            orientation: 'horizontal',
            safesearch: true,
            per_page: 15,                                        // Кількість зображень на сторінку
            page: page,                                          // Номер сторінки  
        },
    };
    
    const response = await axios.get(BASE_URL, searchParams);   // Виконую GET-запит до API Pixabay з використанням axios
    return response.data;                                       // Повертаю отримані дані з відповіді

}